import React from "react";
import styles from "./style.module.css";
import basketballBanner from "../../../Assets/Images/intro_bg.png";

const InstructionCard = () => {
  return (
    <div className={styles.card}>
      <img src={basketballBanner} alt="Instruction" className={styles.image} />
      <h1 className={`${styles.heading} black-text-clip`}>INSTRUCTION</h1>
      <p className={`${styles.subtext} black-text-clip`}>
        Instruction by Sport
      </p>
    </div>
  );
};

export default InstructionCard;
